import { useEffect } from "react";

const setMeta = (attr, key, content, added) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const prev = el?.getAttribute("content");
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); added.push(el); }
  el.setAttribute("content", content);
  return () => { if (prev != null) el.setAttribute("content", prev); };
};

export const useSeo = ({ title, description, canonical, type = "website", jsonLd = [], robots }) => {
  const ld = JSON.stringify(jsonLd);
  useEffect(() => {
    const prevTitle = document.title;
    const added = [];
    const restores = [
      setMeta("name", "description", description, added),
      setMeta("property", "og:title", title, added),
      setMeta("property", "og:description", description, added),
      setMeta("property", "og:type", type, added),
      setMeta("property", "og:url", canonical, added),
    ];
    if (robots) restores.push(setMeta("name", "robots", robots, added));
    document.title = title;
    const link = document.createElement("link");
    link.rel = "canonical"; link.href = canonical;
    document.head.appendChild(link); added.push(link);
    JSON.parse(ld).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json"; s.text = JSON.stringify(obj);
      document.head.appendChild(s); added.push(s);
    });
    return () => { document.title = prevTitle; restores.forEach((r) => r()); added.forEach((el) => el.remove()); };
  }, [title, description, canonical, type, ld, robots]);
};
